import map from '../museum/museumMap';
import carinhas, { ICarinha } from '../museum/carinhas';
import { Coordinate, FloorTypes, Move } from "../model";
import { isMobile } from 'react-device-detect';

const allowedTiles = [FloorTypes.FREE, FloorTypes.DOOR, FloorTypes.SIGN, FloorTypes.BENCH];
const blockedMobileTiles = [FloorTypes.SIGN];

export const canMoveUp = (coord: Coordinate, dir: Move): boolean => {
  if (coord.y === 1) return false;
  if (isMobile && blockedMobileTiles.includes(map[coord.y - 1][coord.x])) return false;

  if (map[coord.y][coord.x] === FloorTypes.BENCH) {
    return dir === 'down';
  }

  return allowedTiles.includes(map[coord.y - 1][coord.x]);
}

export const canMoveDown = (coord: Coordinate, dir: Move): boolean => {
  if (coord.y === map.length - 1) return false;
  if (isMobile && blockedMobileTiles.includes(map[coord.y + 1][coord.x])) return false;

  if (map[coord.y][coord.x] === FloorTypes.BENCH) {
    return dir === 'up';
  }

  return allowedTiles.includes(map[coord.y + 1][coord.x]);
}

export const canMoveRight = (coord: Coordinate, dir: Move): boolean => {
  if (coord.x === map[0].length - 2) return false;
  if (isMobile && blockedMobileTiles.includes(map[coord.y][coord.x + 1])) return false;

  if (map[coord.y][coord.x] === FloorTypes.BENCH) {
    return dir === 'left';
  }

  return allowedTiles.includes(map[coord.y][coord.x + 1]);
}

export const canMoveLeft = (coord: Coordinate, dir: Move): boolean => {
  if (coord.x === 0) return false;
  if (isMobile && blockedMobileTiles.includes(map[coord.y][coord.x - 1])) return false;

  if (map[coord.y][coord.x] === FloorTypes.BENCH) {
    return dir === 'right';
  }

  return allowedTiles.includes(map[coord.y][coord.x - 1]);
}

export const canMove = (move: Move, coord: Coordinate, dir: Move): boolean => {
  if (move === 'up') return canMoveUp(coord, dir);
  if (move === 'down') return canMoveDown(coord, dir);
  if (move === 'left') return canMoveLeft(coord, dir);
  if (move === 'right') return canMoveRight(coord, dir);

  return false;
};

export const isFacingCarinha = (dir: Move, coord: Coordinate): boolean => {
  if (dir === 'up') return carinhas.some(c => c.x === coord.x && c.y === coord.y - 1);
  if (dir === 'right') return carinhas.some(c => c.x === coord.x + 1 && c.y === coord.y);
  if (dir === 'left') return carinhas.some(c => c.x === coord.x - 1 && c.y === coord.y);

  return false;
};

export const isNextToCarinha = (coord: Coordinate): boolean => {
  return carinhas.some(c => (c.x === coord.x && c.y === coord.y - 1) || (c.x === coord.x + 1 && c.y === coord.y));
};

export const getFacedCarinha = (dir: Move, coord: Coordinate): ICarinha | undefined => {
  if (dir === 'up') return carinhas.find(c => c.x === coord.x && c.y === coord.y - 1);
  if (dir === 'down') return carinhas.find(c => c.x === coord.x && c.y === coord.y + 1);
  if (dir === 'left') return carinhas.find(c => c.x === coord.x - 1 && c.y === coord.y);
  if (dir === 'right') return carinhas.find(c => c.x === coord.x + 1 && c.y === coord.y);
  return undefined;
}
